<template>
    <v-container fluid >
        <Lista :getParams="this.params"></Lista>
    </v-container>
</template>

<script>
const Lista = () => import('./components/Lista.vue');
export default {
    name: "CursosReprobados",
    data() {
        return {
            loading: true,
            params: {
                aprobado: false,
            }
        }
    },
    components: {
        Lista
    },
    methods: {

    },
    created() {

    }
}
</script>

<style>

</style>
